import JDSDatepickerDesktopInternal from '@jds/react-generated-sdl/JDSDatepickerDesktopInternal';
import JDSDatepickerMobileInternal from '@jds/react-generated-sdl/JDSDatepickerMobileInternal';
import type { JDSDatepickerDesktopInternalProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerDesktopInternalProps) => {
  const { platform } = useTokenValues();

  const json =
    platform === 'desktop'
      ? JDSDatepickerDesktopInternal
      : JDSDatepickerMobileInternal;
  const {
    state = 'default',
    previousButtonAriaLabel = 'Click to Return',
    closeAriaLabel = 'Click to Close',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { state, previousButtonAriaLabel, closeAriaLabel, ...rest },
    'JDSDatepickerDesktopInternal',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerDesktopInternal = withLogic(
  Component
) as React.FC<JDSDatepickerDesktopInternalProps> & { slotName?: string };

DatepickerDesktopInternal.displayName = 'DatepickerDesktopInternal';
DatepickerDesktopInternal.slotName = 'jds_datepicker_desktop_internal';

export { DatepickerDesktopInternal, type JDSDatepickerDesktopInternalProps };
